// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HEADER_BREAKPOINT } from "@steiner/Overrides/Pages/Header";
import { cartLinkStyles } from "@steiner/Overrides/Widgets/Common/CartLink";
import Cart from "@steiner/XDL/Icons/Cart";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedCompactTextStyles = css`
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: bold;
    line-height: 15px;
`;

cartLinkStyles.headerClickable = {
    iconWrapper: {
        css: css`
            position: relative;
        `,
    },
    icon: {
        src: Cart,
    },
    title: {
        color: "secondary",
        css: css`
            ${({ isCompactHeader }: any) => isCompactHeader && sharedCompactTextStyles}

            ${xScreen("lte", HEADER_BREAKPOINT)} {
                ${sharedCompactTextStyles}
            }
        `,
    },
};

cartLinkStyles.subtitle = {
    size: 10,
    color: "common.white",
    weight: "normal",
    css: css`
        line-height: 14px;
        ${({ isCompactHeader }: any) =>
            !isCompactHeader &&
            css`
                display: none;
                ${xScreen("lte", HEADER_BREAKPOINT)} {
                    display: block;
                }
            `}
    `,
};

cartLinkStyles.count = {
    size: 10,
    color: "text.main",
    weight: "bold",
    css: css`
        line-height: 14px;
        text-align: center;
        padding: 0 3px;

        position: absolute;
        top: 0;
        right: 0;
        transform: translate(50%, -24%);

        background-color: ${color("secondary")};
        border: 1px solid ${color("primary")};
        border-radius: 1px;

        ${({ isCompactHeader }: any) =>
            isCompactHeader &&
            css`
                display: none;
            `}

        ${xScreen("lte", HEADER_BREAKPOINT)} {
            display: none;
        }
    `,
};

cartLinkStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            border-radius: 0;
            padding: 0;
            max-width: 470px;
        `,
    },
    tooltipArrow: {
        width: 12,
        height: 8,
    },
};
